import { writeAgentPreferencesCache } from 'scripts/adapters/stores/lib/legacy_agent_preferences';

export default function setAgentPreferences(context, preferences) {
  context.stores.agentPreferences.set(preferences);
  writeAgentPreferencesCache(preferences);
  const auth = context.stores.auth.get();
  // The gateway rethrows replace failures after notifying the observer, whose
  // onReplaceError already reports them. Swallow here so the rethrow doesn't
  // surface as an unhandled rejection (callers fire-and-forget) or double-report.
  return context.gateways.agentPreferences
    .replace({ agentId: auth.getUserId(), orgId: auth.getOrgId() }, preferences.toJs())
    .catch(() => {});
}
